var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29289 3.73042L7.29289 6.73042C7.68342 7.12095 8.31658 7.12095 8.70711 6.73042L11.7071 3.73042C12.0976 3.3399 12.0976 2.70673 11.7071 2.31621C11.3166 1.92568 10.6834 1.92568 10.2929 2.31621L8 4.6091L5.70711 2.31621C5.31658 1.92568 4.68342 1.92568 4.29289 2.31621C3.90237 2.70673 3.90237 3.3399 4.29289 3.73042ZM11.7071 12.2696L8.70711 9.26963C8.31658 8.8791 7.68342 8.8791 7.29289 9.26963L4.29289 12.2696C3.90237 12.6602 3.90237 13.2933 4.29289 13.6838C4.68342 14.0744 5.31658 14.0744 5.70711 13.6838L8 11.3909L10.2929 13.6838C10.6834 14.0744 11.3166 14.0744 11.7071 13.6838C12.0976 13.2933 12.0976 12.6602 11.7071 12.2696Z",
    fill: "#001A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/Collapse.89d18275961dab64c825264556144c82.svg";
export { ForwardRef as ReactComponent };